class VideoSyncController {
  constructor() {
    this.handlers = new Map();
    this.isRunningSync = false;
    this.syncInterval = null;
    this.activeTabId = null;
    this.currentTime = 0;
    this.updateLock = false;
    this.updateDebounceTimer = null;
  }
  
  registerComponent(id, handlers) {
    this.handlers.set(id, handlers);
    return () => this.handlers.delete(id);
  }
  
  setActiveTab(id) {
    this.activeTabId = id;
  }
  
  updateCurrentTime(time, sourceId) {
    // Return early if locked
    if (this.updateLock) return;
    
    if (time === undefined || time === null) return;
    
    // Debounce updates to prevent rapid firing
    clearTimeout(this.updateDebounceTimer);
    this.updateDebounceTimer = setTimeout(() => {
      if (sourceId && sourceId === this.activeTabId) {
        this.currentTime = time;
        
        // Set lock before syncing
        this.updateLock = true;
        this.syncTime(sourceId);
        
        // Release lock after a short delay
        setTimeout(() => {
          this.updateLock = false;
        }, 50);
      }
    }, 50);
  }
  
  syncTime(sourceId) {
    if (this.isRunningSync) return;
    
    this.isRunningSync = true;
    
    this.handlers.forEach((handlers, id) => {
      if (id !== sourceId && handlers.onTimeSync) {
        try {
          handlers.onTimeSync(this.currentTime);
        } catch (err) {
          console.error(`Error syncing time to ${id}:`, err);
        }
      }
    });
    
    setTimeout(() => {
      this.isRunningSync = false;
    }, 50);
  }
  
  playAll(sourceId) {
    this.handlers.forEach((handlers, id) => {
      if (id !== sourceId && handlers.onPlay) {
        try {
          handlers.onPlay();
        } catch (err) {
          console.error(`Error playing ${id}:`, err);
        }
      }
    });
  }
  
  pauseAll(sourceId) {
    this.handlers.forEach((handlers, id) => {
      if (id !== sourceId && handlers.onPause) {
        try {
          handlers.onPause();
        } catch (err) {
          console.error(`Error pausing ${id}:`, err);
        }
      }
    });
  }
  
  startPeriodicSync(interval = 200) {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
    }
    
    this.syncInterval = setInterval(() => {
      if (!this.isRunningSync) {
        this.syncTime();
      }
    }, interval);
  }
  
  stopPeriodicSync() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
      this.syncInterval = null;
    }
  }
}

const videoSyncController = new VideoSyncController();
export default videoSyncController;